import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  connectionStatus: "idle",
  reconnectAttempts: 0,
  pendingAnswersCount: 0,
  connectionMessage: null,
  isOnline: typeof navigator !== "undefined" ? navigator.onLine : true,
};

const websocketSlice = createSlice({
  name: "websocket",
  initialState,
  reducers: {
    wsConnecting(state) {
      state.connectionStatus = "connecting";
    },
    wsConnected(state) {
      state.connectionStatus = "connected";
      state.reconnectAttempts = 0;
    },
    wsDisconnected(state) {
      state.connectionStatus = "disconnected";
      state.reconnectAttempts += 1;
    },
    wsError(state, action) {
      state.connectionStatus = "error";
      state.connectionMessage = action.payload;
    },
    setReconnectAttempts(state, action) {
      state.reconnectAttempts = action.payload;
    },
    setPendingAnswersCount(state, action) {
      state.pendingAnswersCount = action.payload;
    },
    setNetworkOnline(state, action) {
      state.isOnline = action.payload;
      if (!action.payload) {
        state.connectionStatus = "disconnected";
      }
    },
  },
});

export const {
  wsConnecting,
  wsConnected,
  wsDisconnected,
  wsError,
  setReconnectAttempts,
  setPendingAnswersCount,
  setNetworkOnline,
} = websocketSlice.actions;

export default websocketSlice.reducer;